import { slidingWindow } from "../utils";
import { Momentum as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { windowSize, sourcePath } = options;

    const algo = slidingWindow()
      .windowSize(windowSize + 1)
      .sourcePath(sourcePath)
      .accumulator((values) => {
        // values[0] is the oldest (i - period)
        // values[windowSize] is the current (i)
        const pastValue = values[0];
        const currentValue = values[windowSize];

        // Momentum = Close[i] - Close[i - Period]
        return currentValue - pastValue;
      });

    return algo(data);
  }

  calculator.undefinedLength = function () {
    return options.windowSize;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
